export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4981.82b78c0f.jpg";